var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jolly-beans-container", class: { mobile: _vm.isMobile } },
    [
      _c("div", { staticClass: "container1" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showRecordsView,
                expression: "!showRecordsView",
              },
            ],
            staticClass: "content3",
          },
          [
            _c("div", { staticClass: "happy-coin" }, [_vm._v("欢乐豆")]),
            _c(
              "div",
              {
                staticClass: "block5",
                on: {
                  click: function ($event) {
                    return _vm.openRecordsView("game")
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "image55",
                  attrs: {
                    src: require("./assets/Image14.png"),
                    alt: "Image Asset 14",
                    width: "25",
                    height: "18",
                  },
                }),
                _c("span", { staticClass: "label" }, [_vm._v("游戏记录")]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "block4",
                on: {
                  click: function ($event) {
                    return _vm.openRecordsView("balance")
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "image54",
                  attrs: {
                    src: require("./assets/Image15.png"),
                    alt: "Image Asset 15",
                    width: "21",
                    height: "24",
                  },
                }),
                _c("span", { staticClass: "label" }, [_vm._v("余额记录")]),
              ]
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showRecordsView,
                expression: "showRecordsView",
              },
            ],
            staticClass: "records-view",
          },
          [
            _c("div", { staticClass: "records-view-header" }, [
              _c("span", {
                staticClass: "records-view-back el-icon-arrow-left",
                on: {
                  click: function ($event) {
                    _vm.showRecordsView = false
                  },
                },
              }),
              _c("div", { staticClass: "records-view-tabs" }, [
                _c(
                  "span",
                  {
                    staticClass: "records-tab",
                    class: { active: _vm.recordTab === "game" },
                    on: {
                      click: function ($event) {
                        _vm.recordTab = "game"
                      },
                    },
                  },
                  [_vm._v("游戏记录")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "records-tab",
                    class: { active: _vm.recordTab === "balance" },
                    on: {
                      click: function ($event) {
                        _vm.recordTab = "balance"
                      },
                    },
                  },
                  [_vm._v("余额记录")]
                ),
              ]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.recordTab === "game",
                    expression: "recordTab === 'game'",
                  },
                ],
                staticClass: "records-view-body",
              },
              [
                _c(
                  "div",
                  {
                    ref: "recordsGameListScroll",
                    staticClass: "records-scroll-area records-game-list",
                    on: { scroll: _vm.onRecordsGameListScroll },
                  },
                  [
                    _vm.gameRecordsFirstLoad &&
                    _vm.gameRecordsLoading &&
                    _vm.gameRecords.length === 0
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "records-game-grid records-game-skeleton",
                            },
                            _vm._l(6, function (n) {
                              return _c(
                                "div",
                                {
                                  key: "skeleton-" + n,
                                  staticClass:
                                    "records-game-card records-game-card--skeleton",
                                },
                                [
                                  _vm._m(0, true),
                                  _vm._m(1, true),
                                  _vm._m(2, true),
                                  _vm._m(3, true),
                                  _vm._m(4, true),
                                  _vm._m(5, true),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      : [
                          _vm.gameRecords.length === 0
                            ? _c(
                                "div",
                                { staticClass: "records-game-empty" },
                                [
                                  _c("el-empty", {
                                    attrs: { "image-size": 200 },
                                  }),
                                ],
                                1
                              )
                            : [
                                _c(
                                  "div",
                                  { staticClass: "records-game-grid" },
                                  _vm._l(_vm.gameRecords, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "records-game-card",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "records-card-row" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "records-card-label",
                                              },
                                              [_vm._v("游戏名称:")]
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(item.gameName)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "records-card-row" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "records-card-label",
                                              },
                                              [_vm._v("游戏编号:")]
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(item.gameId)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "records-card-row" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "records-card-label",
                                              },
                                              [_vm._v("游戏时间:")]
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(item.betTime)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "records-card-row" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "records-card-label",
                                              },
                                              [_vm._v("战力值:")]
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(item.betAmount)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _c(
                                  "div",
                                  { staticClass: "records-game-load-more" },
                                  [
                                    _vm.gameRecordsLoading
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "records-loading-text",
                                          },
                                          [_vm._v("加载中...")]
                                        )
                                      : _vm.gameRecordsHasMore
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "records-load-more-hint",
                                          },
                                          [_vm._v("上拉加载更多")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "records-no-more" },
                                          [_vm._v("没有更多了")]
                                        ),
                                  ]
                                ),
                              ],
                        ],
                  ],
                  2
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.recordTab === "balance",
                    expression: "recordTab === 'balance'",
                  },
                ],
                staticClass: "records-view-body",
              },
              [
                _c(
                  "div",
                  {
                    ref: "recordsBalanceListScroll",
                    staticClass:
                      "records-scroll-area records-balance-table-wrap",
                    on: { scroll: _vm.onRecordsBalanceListScroll },
                  },
                  [
                    _vm.balanceRecordsFirstLoad &&
                    _vm.balanceRecordsLoading &&
                    _vm.balanceRecords.length === 0
                      ? [
                          _c(
                            "div",
                            { staticClass: "records-balance-skeleton" },
                            _vm._l(8, function (n) {
                              return _c(
                                "div",
                                {
                                  key: "skeleton-" + n,
                                  staticClass: "records-balance-skeleton-row",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "records-skeleton-line records-balance-skeleton-cell",
                                  }),
                                  _c("span", {
                                    staticClass:
                                      "records-skeleton-line records-balance-skeleton-cell",
                                  }),
                                  _c("span", {
                                    staticClass:
                                      "records-skeleton-line records-balance-skeleton-cell",
                                  }),
                                  _c("span", {
                                    staticClass:
                                      "records-skeleton-line records-balance-skeleton-cell",
                                  }),
                                  _c("span", {
                                    staticClass:
                                      "records-skeleton-line records-balance-skeleton-cell",
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      : [
                          _vm.balanceRecords.length === 0
                            ? _c(
                                "div",
                                { staticClass: "records-balance-empty" },
                                [
                                  _c("el-empty", {
                                    attrs: { "image-size": 200 },
                                  }),
                                ],
                                1
                              )
                            : [
                                _c(
                                  "table",
                                  { staticClass: "records-balance-table" },
                                  [
                                    _vm._m(6),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.balanceRecords,
                                        function (row) {
                                          return _c("tr", { key: row.id }, [
                                            _c("td", [_vm._v(_vm._s(row.id))]),
                                            _c("td", [
                                              _vm._v(_vm._s(row.detail)),
                                            ]),
                                            _c(
                                              "td",
                                              {
                                                class: {
                                                  "text-green": row.profit > 0,
                                                  "text-red": row.profit < 0,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.profit > 0 ? "+" : ""
                                                    ) +
                                                    _vm._s(row.profit) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("td", [
                                              _c(
                                                "span",
                                                { staticClass: "text-green" },
                                                [_vm._v(_vm._s(row.balance))]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "records-time" },
                                                [_vm._v(_vm._s(row.time))]
                                              ),
                                            ]),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "records-balance-load-more" },
                                  [
                                    _vm.balanceRecordsLoading
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "records-loading-text",
                                          },
                                          [_vm._v("加载中...")]
                                        )
                                      : _vm.balanceRecordsHasMore
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "records-load-more-hint",
                                          },
                                          [_vm._v("上拉加载更多")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "records-no-more" },
                                          [_vm._v("没有更多了")]
                                        ),
                                  ]
                                ),
                              ],
                        ],
                  ],
                  2
                ),
              ]
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showRecordsView,
                expression: "!showRecordsView",
              },
            ],
            staticClass: "content2",
          },
          [
            _c("div", { staticClass: "block1" }, [
              _c("div", { staticClass: "main9" }, [
                _c("div", { staticClass: "image31" }, [
                  _c("div", { staticClass: "subSection4" }, [
                    _c("img", {
                      staticClass: "image32",
                      attrs: {
                        src: require("./assets/Image36.png"),
                        alt: "Image Asset 36",
                      },
                    }),
                    _c("img", {
                      staticClass: "image33",
                      attrs: {
                        src: require("./assets/Image37.png"),
                        alt: "Image Asset 37",
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "subSection5" }, [
                    _c("div", { staticClass: "subBlock2" }, [
                      _c("img", {
                        staticClass: "image36",
                        attrs: {
                          src: require("./assets/Image38.png"),
                          alt: "Image Asset 38",
                        },
                      }),
                      _c("div", { staticClass: "daily-reward-amount" }, [
                        _vm._v(" " + _vm._s(_vm.consecutiveAmount) + " "),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "subBlock1",
                        on: { click: _vm.handleClaimConsecutiveHappyCoin },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.consecutiveClaimed ? "已领取过" : "领取"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "login-right-container",
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "flex-end",
                    width: "100%",
                    "justify-content": "space-between",
                    position: "relative",
                    top: "-20px",
                  },
                },
                [
                  _c("div", { staticClass: "main7" }, [
                    _c("div", { staticClass: "image14 continuous-login" }, [
                      _c("div", { staticClass: "continuous-login-inner" }, [
                        _c("div", { staticClass: "continuous-login-header" }, [
                          _c(
                            "span",
                            { staticClass: "continuous-login-title" },
                            [_vm._v("连续登陆")]
                          ),
                          _c("span", { staticClass: "continuous-login-desc" }, [
                            _vm._v(
                              " 连续登陆第" +
                                _vm._s(_vm.consecutiveClaimDay) +
                                "天"
                            ),
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm.consecutiveClaimed ? "已领取" : "可领取"
                                ) + _vm._s(_vm.consecutiveClaimAmount)
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "continuous-login-timeline" },
                          [
                            _c("div", {
                              staticClass:
                                "continuous-login-line continuous-login-line-bg",
                            }),
                            _c("div", {
                              staticClass:
                                "continuous-login-line continuous-login-line-fill",
                              style: {
                                width: _vm.continuousLoginProgressPercent + "%",
                              },
                            }),
                            _vm._l(
                              _vm.consecutiveLoginList,
                              function (item, i) {
                                return _c(
                                  "div",
                                  {
                                    key: i,
                                    staticClass: "continuous-login-point",
                                    style: {
                                      left: _vm.getContinuousPointLeft(i) + "%",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "continuous-login-day" },
                                      [_vm._v("第" + _vm._s(item.day) + "天")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "continuous-login-reward",
                                      },
                                      [_vm._v(_vm._s(item.reward))]
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "main8" }, [
                    _c("div", { staticClass: "image24" }, [
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("100000欢乐豆战力值兑换1余额"),
                      ]),
                      _c("div", { staticClass: "subSection3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "subBlock",
                            on: { click: _vm.openRedeemModal },
                          },
                          [_vm._v(" 兑换 ")]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "vip-rights" }, [
              _c("div", { staticClass: "block3" }, [
                _c(
                  "div",
                  {
                    staticClass: "main12",
                    on: {
                      click: function ($event) {
                        _vm.vipRightPanel = "vip"
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "section7" }, [
                      _c("span", { staticClass: "main12-label" }, [
                        _vm._v("当前等级"),
                      ]),
                      _c("div", { staticClass: "subSection8" }, [
                        _c("div", { staticClass: "subBlock6" }, [
                          _c("span", [
                            _vm._v(
                              "VIP" +
                                _vm._s(_vm.currentVipLevel) +
                                " " +
                                _vm._s(_vm.currentBoostPercent) +
                                "%加成中..."
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "section6" }, [
                      _c("span", { staticClass: "main12-vip" }, [
                        _vm._v("VIP" + _vm._s(_vm.currentVipLevel)),
                      ]),
                      _c("img", {
                        staticClass: "image44",
                        attrs: {
                          src: require("./assets/Image45.png"),
                          alt: "",
                        },
                      }),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "image48",
                    on: {
                      click: function ($event) {
                        _vm.vipRightPanel = "reward"
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "image49",
                      attrs: {
                        src: require("./assets/Image47.png"),
                        alt: "Image Asset 47",
                      },
                    }),
                    _c("div", { staticClass: "alarm" }, [
                      _c("img", {
                        attrs: {
                          src: require("./assets/alarm.png"),
                          alt: "",
                          width: "16",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.timePeriodCountdownText))]),
                    ]),
                    _c("img", {
                      staticClass: "image50",
                      attrs: {
                        src: require("./assets/Image48.png"),
                        alt: "Image Asset 48",
                      },
                    }),
                    _c("div", { staticClass: "section8" }, [
                      _c("div", { staticClass: "subSection9" }, [
                        _c("img", {
                          staticClass: "image51",
                          attrs: {
                            src: require("./assets/Image49.png"),
                            alt: "Image Asset 49",
                          },
                        }),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.vipRightPanel,
                      expression: "vipRightPanel",
                    },
                  ],
                  staticClass: "vip-rights-panel",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.vipRightPanel === "vip",
                          expression: "vipRightPanel === 'vip'",
                        },
                      ],
                      staticClass: "dynBlock",
                    },
                    [
                      _c("div", { staticClass: "main11" }, [
                        _c("div", { staticClass: "vip-header" }, [
                          _c("span", { staticClass: "vip-header-label" }, [
                            _vm._v("当前等级"),
                          ]),
                          _c("div", { staticClass: "vip-current-badge" }, [
                            _vm._v(
                              " VIP" +
                                _vm._s(_vm.currentVipLevel) +
                                " " +
                                _vm._s(_vm.currentBoostPercent) +
                                "%加成中... "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "vip-progress-container" }, [
                          _c(
                            "div",
                            { staticClass: "vip-progress-track" },
                            [
                              _c("div", {
                                staticClass: "vip-progress-fill",
                                style: { width: _vm.progressPercentage + "%" },
                              }),
                              _vm._l(_vm.vipMarkers, function (marker) {
                                return _c(
                                  "div",
                                  {
                                    key: marker.level,
                                    staticClass: "vip-marker",
                                    class: {
                                      "vip-marker-active":
                                        _vm.currentVipLevel >= marker.level,
                                    },
                                    style: { left: marker.position + "%" },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "vip-marker-circle",
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "vip-level-label" },
                                      [_vm._v("VIP" + _vm._s(marker.level))]
                                    ),
                                    marker.boost
                                      ? _c(
                                          "div",
                                          { staticClass: "vip-boost-label" },
                                          [
                                            _vm._v(
                                              " 加成" +
                                                _vm._s(marker.boost) +
                                                "% "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "vip-exp-tooltip",
                                  style: {
                                    left: _vm.expTooltipPositionClamped + "%",
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "vip-tooltip-line",
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "vip-tooltip-content" },
                                    [
                                      _vm._v(
                                        " 当前经验值: " +
                                          _vm._s(_vm.currentExp) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.vipRightPanel === "reward",
                          expression: "vipRightPanel === 'reward'",
                        },
                      ],
                      staticClass: "dynBlock dynBlock-reward",
                    },
                    [
                      _c("div", { staticClass: "reward-panel-header" }, [
                        _c("h3", { staticClass: "reward-panel-title" }, [
                          _vm._v("领取奖励"),
                        ]),
                        _c("div", { staticClass: "reward-panel-tabs" }, [
                          _c(
                            "span",
                            {
                              staticClass: "reward-tab",
                              class: { active: _vm.rewardTab === "daily" },
                              on: {
                                click: function ($event) {
                                  _vm.rewardTab = "daily"
                                },
                              },
                            },
                            [_vm._v("每日奖励")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "reward-tab",
                              class: { active: _vm.rewardTab === "weekly" },
                              on: {
                                click: function ($event) {
                                  _vm.rewardTab = "weekly"
                                },
                              },
                            },
                            [_vm._v("每周奖励")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "reward-tab",
                              class: { active: _vm.rewardTab === "monthly" },
                              on: {
                                click: function ($event) {
                                  _vm.rewardTab = "monthly"
                                },
                              },
                            },
                            [_vm._v("每月奖励")]
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "reward-panel-body" },
                        [
                          _vm.rewardTab === "daily"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "reward-list" },
                                  _vm._l(_vm.dailyRewards, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "reward-item",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "reward-item-left" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "reward-name" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(item.name) + " "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "reward-value",
                                                  },
                                                  [_vm._v(_vm._s(item.value))]
                                                ),
                                                item.desc
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "reward-desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.desc)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            item.extra
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "reward-extra",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.extra) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "reward-item-right" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "reward-status",
                                                class: {
                                                  countdown: item.countdown,
                                                },
                                              },
                                              [_vm._v(_vm._s(item.status))]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "reward-claim-col",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "reward-claim-btn",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleClaimReward(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 领取 ")]
                                                ),
                                                item.type === "timePeriod" &&
                                                !item.canClaim &&
                                                _vm.timePeriodCountdownText
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reward-timeperiod-countdown",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 倒计时 " +
                                                            _vm._s(
                                                              _vm.timePeriodCountdownText
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            : _vm._e(),
                          _vm.rewardTab === "weekly"
                            ? [
                                _vm.weeklyRewardLoading
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "reward-list reward-list--skeleton",
                                        },
                                        _vm._l(3, function (n) {
                                          return _c(
                                            "div",
                                            {
                                              key: "weekly-skeleton-" + n,
                                              staticClass:
                                                "reward-item reward-item--skeleton",
                                            },
                                            [_vm._m(7, true), _vm._m(8, true)]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  : _c(
                                      "div",
                                      { staticClass: "reward-weekly-content" },
                                      [
                                        _vm.weeklyRewardMsg
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "reward-tip reward-tip--weekly",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.weeklyRewardMsg
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.weeklyRewards.length
                                          ? _c(
                                              "div",
                                              { staticClass: "reward-list" },
                                              _vm._l(
                                                _vm.weeklyRewards,
                                                function (item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.id,
                                                      staticClass:
                                                        "reward-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "reward-item-left",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "reward-name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.name
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#fff",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.value
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          item.desc
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "reward-desc",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.desc
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "reward-item-right",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "reward-status",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.status
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "reward-claim-btn",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleClaimReward(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v(" 领取 ")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                              ]
                            : _vm._e(),
                          _vm.rewardTab === "monthly"
                            ? [
                                _vm.monthlyRewardLoading
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "reward-list reward-list--skeleton",
                                        },
                                        _vm._l(2, function (n) {
                                          return _c(
                                            "div",
                                            {
                                              key: "monthly-skeleton-" + n,
                                              staticClass:
                                                "reward-item reward-item--skeleton",
                                            },
                                            [_vm._m(9, true), _vm._m(10, true)]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  : _c(
                                      "div",
                                      { staticClass: "reward-monthly-content" },
                                      [
                                        _vm.monthlyPoints.length
                                          ? _c(
                                              "div",
                                              { staticClass: "reward-monthly" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "reward-monthly-header",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reward-monthly-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "每月" +
                                                            _vm._s(
                                                              _vm.monthlyClaimDay
                                                            ) +
                                                            "号登陆"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reward-monthly-claim",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "monthly-claim-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.monthlyClaimInfo
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "reward-claim-btn reward-claim-btn--monthly",
                                                            on: {
                                                              click:
                                                                _vm.handleClaimMonthly,
                                                            },
                                                          },
                                                          [_vm._v(" 领取 ")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "reward-monthly-timeline",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "reward-timeline-line",
                                                    }),
                                                    _vm._l(
                                                      _vm.monthlyPoints,
                                                      function (point, i) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: i,
                                                            staticClass:
                                                              "reward-timeline-point",
                                                            class: {
                                                              "reward-timeline-point--active":
                                                                point.canClaim,
                                                            },
                                                            style: {
                                                              left:
                                                                point.position +
                                                                "%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "point-time",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    point.time
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "point-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    point.value
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "block2" },
              [
                _c(
                  "el-tabs",
                  {
                    staticClass: "game-type-tabs",
                    on: { "tab-click": _vm.handleGameTypeTabClick },
                    model: {
                      value: _vm.gameTypeTab,
                      callback: function ($$v) {
                        _vm.gameTypeTab = $$v
                      },
                      expression: "gameTypeTab",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { label: "当前等级可体验游戏", name: "upgrade" },
                    }),
                    _c("el-tab-pane", {
                      attrs: { label: "升级所需体验游戏", name: "current" },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "game-list" },
                  [
                    _vm._l(_vm.gameList, function (game, index) {
                      return [
                        !game.flag || _vm.$canShowFeature(game.flag)
                          ? _c(
                              "div",
                              {
                                staticClass: "game-item",
                                style: {
                                  backgroundImage: "url(" + game.src + ")",
                                },
                                attrs: { id: index },
                                on: {
                                  click: function ($event) {
                                    return _vm.goToGame(game.route)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "game-title" }, [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(_vm._s(game.name)),
                                  ]),
                                  _c("div", { staticClass: "icon_hld" }),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showGameTurnoverModal,
              expression: "showGameTurnoverModal",
            },
          ],
          staticClass: "game-turnover-modal-mask",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.closeGameTurnoverModal.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "game-turnover-modal",
              attrs: { role: "dialog", "aria-modal": "true" },
            },
            [
              _c("div", { staticClass: "game-turnover-modal-title" }, [
                _vm._v("温馨提示"),
              ]),
              _c("div", { staticClass: "game-turnover-modal-message" }, [
                _vm._v("该游戏暂不累计欢乐豆流水"),
              ]),
              _c("div", { staticClass: "game-turnover-modal-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "game-turnover-modal-cancel",
                    attrs: { type: "button" },
                    on: { click: _vm.closeGameTurnoverModal },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "game-turnover-modal-confirm",
                    attrs: { type: "button" },
                    on: { click: _vm.enterPendingGame },
                  },
                  [_vm._v("进入游戏")]
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRedeemModal,
              expression: "showRedeemModal",
            },
          ],
          staticClass: "redeem-modal-mask",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              _vm.showRedeemModal = false
            },
          },
        },
        [
          _c("div", { staticClass: "redeem-modal" }, [
            _c("div", { staticClass: "redeem-modal-header" }, [
              _c("h3", { staticClass: "redeem-modal-title" }, [
                _vm._v("兑换欢乐豆"),
              ]),
              _c(
                "svg",
                {
                  staticStyle: { cursor: "pointer" },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "29",
                    height: "29",
                    viewBox: "0 0 29 29",
                    fill: "none",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showRedeemModal = false
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M14.5 27.1875C7.50376 27.1875 1.8125 21.4962 1.8125 14.5C1.8125 7.50376 7.50376 1.8125 14.5 1.8125C21.4962 1.8125 27.1875 7.50376 27.1875 14.5C27.1875 21.4962 21.4962 27.1875 14.5 27.1875ZM14.5 3.63314C8.50786 3.63314 3.63314 8.50786 3.63314 14.5C3.63314 20.4912 8.50786 25.3669 14.5 25.3669C20.4912 25.3669 25.3669 20.4913 25.3669 14.5C25.3669 8.50786 20.4912 3.63314 14.5 3.63314Z",
                      fill: "white",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M15.7743 14.538L19.693 10.6619C20.0491 10.3103 20.0519 9.73665 19.7002 9.38049C19.3486 9.02432 18.774 9.02159 18.4188 9.37323L14.4947 13.2538L10.6305 9.37776C10.2761 9.0234 9.70339 9.02159 9.34902 9.37596C8.99466 9.7294 8.99378 10.303 9.34722 10.6574L13.206 14.528L9.31546 18.3768C8.95929 18.7293 8.95656 19.3021 9.3082 19.6583C9.48582 19.8377 9.71873 19.9274 9.95252 19.9274C10.1827 19.9274 10.4129 19.8395 10.5896 19.6655L14.4856 15.8121L18.4133 19.7525C18.59 19.9302 18.822 20.019 19.0549 20.019C19.2869 20.019 19.518 19.9302 19.6947 19.7543C20.0491 19.4009 20.05 18.8281 19.6965 18.4729L15.7743 14.538Z",
                      fill: "white",
                    },
                  }),
                ]
              ),
            ]),
            _c("div", { staticClass: "redeem-modal-body" }, [
              _c("div", { staticClass: "redeem-desc-section" }, [
                _c("label", { staticClass: "redeem-desc-label" }, [
                  _vm._v("说明:"),
                ]),
                _c("div", { staticClass: "redeem-desc-content" }, [
                  _vm._v(_vm._s(_vm.redeemDesc)),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "redeem-list" },
                [
                  _vm.exchangeConfigLoading && !_vm.exchangeConfig
                    ? _vm._l(3, function (i) {
                        return _c(
                          "div",
                          {
                            key: "skeleton-" + i,
                            staticClass: "redeem-item redeem-item--skeleton",
                          },
                          [
                            _vm._m(11, true),
                            _c("div", { staticClass: "redeem-skeleton-btn" }),
                          ]
                        )
                      })
                    : _vm._l(_vm.redeemItems, function (item) {
                        return _c(
                          "div",
                          { key: item.id, staticClass: "redeem-item" },
                          [
                            _c("div", { staticClass: "redeem-item-left" }, [
                              _c("div", { staticClass: "redeem-condition" }, [
                                _vm._v(
                                  " 当前可用欢乐豆战力: " +
                                    _vm._s(item.currentTurnover) +
                                    "，当前欢乐豆: " +
                                    _vm._s(_vm.user.happyCoin) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c(
                              "button",
                              {
                                staticClass: "redeem-item-btn",
                                class: {
                                  "redeem-item-btn--claimable": item.claimable,
                                },
                                attrs: { disabled: !item.claimable },
                                on: {
                                  click: function ($event) {
                                    item.claimable && _vm.handleRedeem(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(item.claimable ? "兑换" : "未达到") +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                ],
                2
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "records-card-row" }, [
      _c("span", { staticClass: "records-card-label records-skeleton-line" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "records-card-row" }, [
      _c("span", { staticClass: "records-card-label records-skeleton-line" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "records-card-row" }, [
      _c("span", { staticClass: "records-card-label records-skeleton-line" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "records-card-row" }, [
      _c("span", { staticClass: "records-card-label records-skeleton-line" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "records-card-row" }, [
      _c("span", { staticClass: "records-card-label records-skeleton-line" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "records-card-row" }, [
      _c("span", { staticClass: "records-card-label records-skeleton-line" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("流水号")]),
        _c("th", [_vm._v("游戏")]),
        _c("th", [_vm._v("额度")]),
        _c("th", [_vm._v("余额")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reward-item-left" }, [
      _c("div", {
        staticClass: "reward-skeleton-line reward-skeleton-line--title",
      }),
      _c("div", {
        staticClass: "reward-skeleton-line reward-skeleton-line--short",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reward-item-right" }, [
      _c("div", { staticClass: "reward-skeleton-btn" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reward-item-left" }, [
      _c("div", {
        staticClass: "reward-skeleton-line reward-skeleton-line--title",
      }),
      _c("div", {
        staticClass: "reward-skeleton-line reward-skeleton-line--short",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reward-item-right" }, [
      _c("div", { staticClass: "reward-skeleton-btn" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "redeem-item-left" }, [
      _c("div", {
        staticClass: "redeem-skeleton-line redeem-skeleton-line--title",
      }),
      _c("div", {
        staticClass: "redeem-skeleton-line redeem-skeleton-line--short",
      }),
      _c("div", {
        staticClass: "redeem-skeleton-line redeem-skeleton-line--medium",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }